<template>
    <div>
        <tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :helper_text="helper_text" :fabricator="fabricator">
        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalProfile from "../DesignerQuestionTechnicalProfile.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalProfile
        ],
        props: {
            title: {
                default(){
                    return 'Select A Profile';
                }
            },
            helper_text: {
                default() {
                    return '';
                }
            },
            doorRange: {
              default() {
                return 0;
              }
            },
            frameColourInternal: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            frameMaterial: {
                required: true,
            },
            securedByDesign: {
                required: true
            },
            hardwareHandle: {
                required: false,
                default() {
                    return 0;
                }
            },
            hardwareEscutcheon: {
                required: false,
                default() {
                    return 0;
                }
            },
            frameCombination: {
              required: false,
              default() {
                return 0;
              }
            },
            openingDirection: {
                required: true,
            },
            panelCategory: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/profile/';
            },
            passed_filter(){
                return this.variable_ready(this.frameColourExternal, this.frameColourInternal, this.frameMaterial, this.securedByDesign, this.hardwareHandle, this.hardwareEscutcheon, this.doorRange, this.frameCombination, this.openingDirection, this.panelCategory);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-profile?secured_by_design=' + this.securedByDesign + '&frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&frame_material=' + this.frameMaterial + '&hardware_handle=' + this.hardwareHandle + '&hardware_escutcheon=' + this.hardwareEscutcheon + '&door_range=' + this.doorRange + '&frame_combination=' + this.frameCombination + '&opening_direction=' + this.openingDirection + '&panel_category=' + this.panelCategory;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.frameColourExternal + '_' + this.frameColourInternal + '_' + this.frameMaterial + '_' + this.securedByDesign + '_' + this.hardwareHandle + '_' + this.hardwareEscutcheon + '_' + this.doorRange + '_' + this.frameCombination + '_' + this.openingDirection + '_' + this.panelCategory;
            },
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
